import { setSafeInnerHTML } from './htmlSecurityModule.js';

export function waitForStableElementSizeFallback(el) {
  if (!el) return { width: 0, height: 0 };
  const rect = el.getBoundingClientRect();
  return { width: Math.round(rect.width), height: Math.round(rect.height) };
}

export function clearTocSearchFallback(elements) {
  if (elements.tocSearchInput) {
    elements.tocSearchInput.value = '';
  }
  if (elements.tocSearchClear) {
    elements.tocSearchClear.style.display = 'none';
  }
  if (elements.tocSearchResults) {
    elements.tocSearchResults.style.display = 'none';
    setSafeInnerHTML(elements.tocSearchResults, '', { profile: 'app' });
  }
  if (elements.tocList) {
    elements.tocList.style.display = 'flex';
  }
}

export function toggleTocFallback({
  elements,
  closeAllPanels,
  clearTocSearch,
  ensureReaderTocModuleReady
}) {
  elements.tocSidebar?.classList.toggle('active');
  closeAllPanels?.();
  if (elements.tocSidebar?.classList.contains('active')) {
    clearTocSearch?.();
  }

  ensureReaderTocModuleReady?.().catch(() => {});
}

export function bindReaderOverlayOutsideCloseFallback({ elements, closeAllPanels, documentRef = document }) {
  elements.readerOverlay?.addEventListener('click', (e) => {
    if (!e.target.closest('.reader-panel') && !e.target.closest('.icon-btn')) {
      closeAllPanels?.();
    }
  });

  const closeTocSidebarIfOutside = (e) => {
    if (!elements.readerOverlay?.classList.contains('active')) return;
    if (!elements.tocSidebar?.classList.contains('active')) return;
    const target = e.target;
    if (target?.closest?.('#tocSidebar') || target?.closest?.('#tocBtn')) return;
    elements.tocSidebar.classList.remove('active');
  };

  documentRef.addEventListener('pointerdown', closeTocSidebarIfOutside, true);
  documentRef.addEventListener('touchstart', closeTocSidebarIfOutside, { capture: true, passive: true });
}

export function togglePanelFallback(panelId, closeAllPanels, documentRef = document) {
  const panel = documentRef.getElementById(panelId);
  if (!panel) return;
  const isActive = panel.classList.contains('active');

  closeAllPanels?.();

  if (!isActive) {
    panel.classList.add('active');
  }
}

export function closeAllPanelsFallback(elements) {
  elements.fontPanel?.classList.remove('active');
  elements.themePanel?.classList.remove('active');
  elements.searchPanel?.classList.remove('active');
  elements.bookmarksPanel?.classList.remove('active');
  elements.ttsPanel?.classList.remove('active');
  elements.autoScrollPanel?.classList.remove('active');
  elements.timerPanel?.classList.remove('active');
}
